import { useEffect, useRef } from "react";

export default function useTabSync({
    onLogin = () => { },
    onLogout = () => { },
    onOrgSwitch = () => { }
} = {}) {
    const tabId = useRef(`${Date.now()}-${Math.random()}`);

    useEffect(() => {
        const bc = new BroadcastChannel("AUTH_SYNC");
        const flags = {
            redirectOnLogin: false,
            logoutNow: false,
            refreshOnOrgSwitch: false
        };

        bc.onmessage = (event) => {
            const { type, originTab } = event.data || {};

            if (originTab === tabId.current) return;

            switch (type) {
                case "LOGIN":
                    flags.redirectOnLogin = true;
                    break;

                case "LOGOUT":
                    flags.logoutNow = true;
                    break;

                case "ORG_SWITCHED":
                    flags.refreshOnOrgSwitch = true;
                    break;
            }
        };

        const onVisibility = () => {
            if (document.visibilityState !== "visible") return;

            if (flags.redirectOnLogin) {
                flags.redirectOnLogin = false;
                onLogin();
            }

            if (flags.logoutNow) {
                flags.logoutNow = false;
                onLogout();
            }

            if (flags.refreshOnOrgSwitch) {
                flags.refreshOnOrgSwitch = false;
                onOrgSwitch();
            }
        };

        document.addEventListener("visibilitychange", onVisibility);

        return () => {
            bc.close();
            document.removeEventListener("visibilitychange", onVisibility);
        };
    }, [onLogin, onLogout, onOrgSwitch]);

    return {
        broadcast(eventType) {
            const bc = new BroadcastChannel("AUTH_SYNC");
            bc.postMessage({ type: eventType, originTab: tabId.current });
            bc.close();
        }
    };
}